import axiosBase from "@/api/axiosBase";

const state = {
    folderTypes: [],
    currentFolderPageSetting:null, //存放基础数据当前文件夹的页面设置信息
}

const getters = {

}

const actions = {
    //获取所有文件夹类型
    getFolderType({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/folder/alltype'
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                else{
                    commit('setFolderTypes', res.data.data.sort((a, b)=>a.id - b.id));
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //根据文件夹类型分页查询
    getFoldersByFolderType({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            let url = '/basedata/folder/page?type_id=' + data.typeId;
            if(data.hasOwnProperty('projectId') && data.projectId != null && data.projectId != ''){
                url+='&project_id=' + data.projectId;
            }
            if(data.hasOwnProperty('folderName') && data.folderName != null && data.folderName != ''){
                url+='&folder_name=' + data.folderName;
            }
            if(data.hasOwnProperty('pageSize') && data.pageSize != null && data.pageSize != ''){
                url+='&page_size=' + data.pageSize;
            }
            if(data.hasOwnProperty('pageNum') && data.pageNum != null && data.pageNum != ''){
                url+='&page=' + data.pageNum;
            }
            if(data.hasOwnProperty('orderCol') && data.orderCol != null && data.orderCol != ''){
                url+='&sort_by=' + data.orderCol;
            }
            if(data.hasOwnProperty('isAsc') && data.isAsc != null && data.isAsc != ''){
                url+='&sort_direction=' + data.isAsc.toUpperCase();
            }
            axiosBase({
                method: 'GET',
                url: url
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //新建文件夹, 
    //直接新建，后台处理重复问题
    addNewFolder({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/folder/create',
                data:{
                    "project_id": data.projectId,
                    "type_id": data.typeId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //修改文件夹
    updateFolder({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/folder/update',
                data:{
                    "folder_id": data.folderId,
                    "folder_name": data.folderName,
                    "project_id": data.projectId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //删除文件夹
    deleteFolder({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/folder/delete',
                data:data.folderIds
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //根据文件夹ID查询文件信息--分页
    getFilesByFolderId({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            let url = '/basedata/filebase/page?';
            if(data.hasOwnProperty('folderId') && data.folderId != null && data.folderId != ''){
                if(!url.endsWith('?')){
                    url += '&';
                }
                url+='folder_id=' + data.folderId;
            }
            if(data.hasOwnProperty('fileId') && data.fileId != null && data.fileId != ''){
                if(!url.endsWith('?')){
                    url += '&';
                }
                url+='file_id=' + data.fileId;
            }
            if(data.hasOwnProperty('fileName') && data.fileName != null && data.fileName != ''){
                if(!url.endsWith('?')){
                    url += '&';
                }
                url+='file_name=' + data.fileName;
            }
            if(data.hasOwnProperty('pageSize') && data.pageSize != null && data.pageSize != ''){
                if(!url.endsWith('?')){
                    url += '&';
                }
                url+='page_size=' + data.pageSize;
            }
            if(data.hasOwnProperty('pageNum') && data.pageNum != null && data.pageNum != ''){
                if(!url.endsWith('?')){
                    url += '&';
                }
                url+='page=' + data.pageNum;
            }
            if(data.hasOwnProperty('orderByColumn') && data.orderByColumn != null && data.orderByColumn != ''){
                if(!url.endsWith('?')){
                    url += '&';
                }
                url+='sort_by=' + data.orderByColumn;
            }
            if(data.hasOwnProperty('isAsc') && data.isAsc != null && data.isAsc != ''){
                if(!url.endsWith('?')){
                    url += '&';
                }
                url+='sort_direction=' + data.isAsc.toUpperCase();
            }
            axiosBase({
                method:'GET',
                url:url
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //修改文件名
    updateFileName({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/update',
                data: {
                    "file_id": data.fileId,
                    "file_name": data.fileName
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //删除文件
    deleteFile({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/delete',
                data: data.fileIds
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取文件树
    getFileTree({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/tree',
                data: {
                    "project_id": data.projectId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //分布查询文件详情
    getFileDetailByPage({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/detail',
                data:{
                    "file_id": data.fileId,
                    "page_num": data.pageNum,
                    "page_size": data.pageSize
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //文件下载
    downloadFiles({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/download',
                data: data.fileIds,
                headers:{
                    'Content-Type':'application/json'
                },
                responseType: 'blob'
            }).then(res=>{
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //文件上传
    updateFiles({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            let formData=new FormData();
            formData.append('file',data.file);
            formData.append('filename',data.file.name)
            axiosBase({
                method:'POST',
                url:'/basedata/upload?folder_id=' + data.folder_id + '&file_size=' + data.file.size,
                data:formData
            })
            .then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}});
            })
        })
    },
    //判断文件上传大小是否满足
    checkFileSize({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/check_upload_size?size=' + data.size,
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取时间序列
    getTimeSeries({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/statistics/timeseries',
                data: {
                    "file_ids": data.fileIds,
                    "start_time": data.st,
                    "end_time": data.et
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取降雨场次
    getRains({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/statistics/rfe',
                data: {
                    "file_id": data.fileId,
                    "scale": data.scale,
                    "start_time": data.st,
                    "end_time": data.et
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取其它统计信息
    getOherStatistic({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/statistics/other',
                data: {
                    "file_id": data.fileId,
                    "scale": data.scale,
                    "start_time": (data.st == '' || data.st == undefined) ? null : data.st,
                    "end_time": (data.et == '' || data.et == undefined) ? null : data.et
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //查询站点
    getStations({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/station',
                data: data.fileIds
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取站点类型
    getStationTypes({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/station/types'
            }).then(res=>{
                let types = [];
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                else{
                    switch(parseInt(data.menuId)){
                        case 1:
                            types = res.data.data['weather'];
                            break;
                        case 2:
                            types = res.data.data['gis'];
                            break;
                        case 3:
                            types = res.data.data['envm'];
                            break;
                        case 4:
                            types = res.data.data['wcf'];
                            break;
                        case 5:
                            types = res.data.data['pollution'];
                            break;
                        case 6:
                            types = res.data.data['socio'];
                            break;
                    }
                }
                resolve(types)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //修改站点
    updateStation({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/station/update',
                data: data.stations
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //移动到
    fileMoveTo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/move',
                data: {
                    "target_folder_id": data.targetFolderId,
                    "file_ids": data.fileIds
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //根据文件ID获取文件信息
    getFileInfoByID({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/list',
                data: data.fileIds
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //增加文件引用，如环境监测数据
    updateFileUse({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/fileuse/add',
                data:{
                    "model_id": data.model_id,
                    "file_ids": data.file_ids
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //删除文件引用
    deleteFileUse({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/filebase/fileuse/delete',
                data:{
                    "model_id": data.model_id,
                    "file_ids": data.file_ids
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //导出shp
    dbExportSHP({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/gis/export_shp',
                data:data,
                headers:{
                    'Content-Type':'application/json'
                },
                responseType: 'blob'
            }).then(res=>{
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //降雨相关性分析
    getRainAnalysis({dispatch, commit}, data){
        return new Promise((resolve, reject) => {
            axiosBase({
                method:'POST',
                url:'/basedata/statistics/correlation',
                data:{
                    "end_time": data.end_time,
                    "file_ids": data.file_ids,
                    "scales": data.scales,
                    "start_time": data.start_time
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    }
}

const mutations = {
    setFolderTypes(state, folderTypes){
        state.folderTypes = folderTypes;
    },
    setFolderPageSetting(state, setting){
        state.currentFolderPageSetting = setting;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}